<template>
  <div class="main-container">
    <p>404</p>
    <span>Ops! Esta página não existe.</span>
    <AppButton text="Voltar" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppButton from "../components/AppButton.vue";

export default {
  name: "PageNotFound",
  components: {
    AppButton
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getUserId"])
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped></style>
